import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "aepstack"
    }}>{`AEPStack`}</h1>
    <p>{`The AEPStack class is a fundamental layout container used to arrange multiple UI elements horizontally or vertically.`}</p>
    <p>{`AEPStack conforms to `}<inlineCode parentName="p">{`ObservableObject`}</inlineCode>{`, allowing it to be used reactively in SwiftUI views.`}</p>
    <h2 {...{
      "id": "public-properties"
    }}>{`Public Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`spacing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`CGFloat`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The spacing between child views in the stack.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`8`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`modifier`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`AEPViewModifier`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A custom view modifier for additional styling.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
        </tr>
      </tbody>
    </table>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`All properties are marked with `}<a parentName="p" {...{
        "href": "https://developer.apple.com/documentation/combine/published"
      }}>{`@Published`}</a>{`. Any changes will trigger updates to your UI.`}</p>
    <h1 {...{
      "id": "aephstack"
    }}>{`AEPHStack`}</h1>
    <p>{`The AEPHStack class extends AEPStack and arranges its child views horizontally. It provides additional customization for aligning child views vertically.`}</p>
    <h2 {...{
      "id": "public-properties-1"
    }}>{`Public Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`alignment`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://developer.apple.com/documentation/swiftui/verticalalignment"
            }}>{`VerticalAlignment`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The vertical alignment of child views in the stack.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://developer.apple.com/documentation/swiftui/verticalalignment/center"
            }}>{`center`}</a></td>
        </tr>
      </tbody>
    </table>
    <h1 {...{
      "id": "aepvstack"
    }}>{`AEPVStack`}</h1>
    <p>{`The AEPVStack class extends AEPStack and arranges its child views vertically. It provides additional customization for aligning child views horizontally.`}</p>
    <h2 {...{
      "id": "public-properties-2"
    }}>{`Public Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`alignment`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://developer.apple.com/documentation/swiftui/horizontalalignment"
            }}>{`HorizontalAlignment`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The horizontal alignment of child views in the stack.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://developer.apple.com/documentation/swiftui/horizontalalignment/center"
            }}>{`center`}</a></td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "customization"
    }}>{`Customization`}</h2>
    <p>{`Below is an example of how to customize the AEPHStack and AEPVStack properties when working with a `}<inlineCode parentName="p">{`SmallImageTemplate`}</inlineCode>{`:`}</p>
    <CodeBlock slots="heading, code" repeat="1" languages="Swift" mdxType="CodeBlock" />
    <h4 {...{
      "id": "swift"
    }}>{`Swift`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`class MyCustomizer : ContentCardCustomizing {
    
    func customize(template: SmallImageTemplate) {        
        // customize stack properties
        template.rootHStack.spacing = 10
        template.textVStack.alignment = .leading
        template.textVStack.spacing = 20
        
        // Customize the button stack 
        template.buttonHStack.modifier = AEPViewModifier(ButtonHStackModifier())        
    }
    
    struct ButtonStackModifier: ViewModifier {
        func body(content: Content) -> some View {
            content
                .frame(maxWidth: .infinity, alignment: .trailing)
        }
    }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      